routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	$locationProvider.html5Mode(true);
	$stateProvider
	.state('strategicTracking', {
		abstract: false,
		url: '/strategicTracking',
		redirectTo: 'strategicTracking.strategicTrackingList',
		views: {
			'': {
				template: require('../../../layout/layout.html')
			},
			'content': {
				template: require('../../../layout/content.html'),
			},
			'aside': {
				template: require('../../../layout/aside.html'),
				controller: 'AsideCtrl'
			},
			'header': {
				template: require('../../../layout/header.html'),
				controller: 'HeaderCtrl'
			},
	      	'chatbox': {
		        template: require('../chatbox/chatbox.html'),
		        controller: 'ChatboxController',
		        controllerAs: 'chatbox'
	      	},
		    'footer': {
		        template: require('../../../layout/footer.html')
		    }
		},
		data: {
			displayName: 'Inicio'
		}
	})
	.state('strategicTracking.strategicTrackingList', {
		abstract: false,
		url: '/list',
		template: require('./list/strategicTrackingList.html'),
		controller: 'strategicTrackingListCtrl',
		controllerAs: 'trackCtrl',
		data: {
			displayName: 'Seguimiento Estratégico'
		}
	})
	.state('strategicTracking.strategicTrackingTeacher', {
		abstract: false,
		url: '/charts/teacher/:acaUnit?workplanId&stateId',
		template: require('./chartsDetails/chartsDetails.html'),
		controller: 'chartsDetailsCtrl',
		controllerAs: 'cDetails',
		data: {
			displayName: 'Docencia',
			order: 1,
			siblings: [{
				name: 'strategicTracking.strategicTrackingAcadManagement',
				hideLink: false,
				order: 5,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidation',
				hideLink: false,
				order: 4,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigation',
				hideLink: false,
				order: 2,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingExtension',
				hideLink: false,
				order: 3,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingGlobalView',
				hideLink: false,
				order: 6,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			}]
		},
		params: {
			idModule: 2
		}, 
	})
	.state('strategicTracking.strategicTrackingAcadManagement', {
		abstract: false,
		url: '/charts/cademicManagement/:acaUnit?workplanId&stateId',
		template: require('./chartsDetails/chartsDetails.html'),
		controller: 'chartsDetailsCtrl',
		controllerAs: 'cDetails',
		params: {
			idModule: 3
		},
		data: {
			displayName: 'Gestión académica',
			order: 5,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacher',
				hideLink: false,
				order: 1,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidation',
				hideLink: false,
				order: 4,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigation',
				hideLink: false,
				order: 2,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingExtension',
				hideLink: false,
				order: 3,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingGlobalView',
				hideLink: false,
				order: 6,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingConsolidation', {
		abstract: false,
		url: '/charts/consolidation/:acaUnit?workplanId&stateId',
		template: require('./chartsDetails/chartsDetails.html'),
		controller: 'chartsDetailsCtrl',
		controllerAs: 'cDetails',
		params: {
			idModule: 5
		},
		data: {
			displayName: 'Consolidación de cuerpo profesoral',
			order: 4,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacher',
				hideLink: false,
				order: 1,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingAcadManagement',
				hideLink: false,
				order: 5,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigation',
				hideLink: false,
				order: 2,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingExtension',
				hideLink: false,
				order: 3,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingGlobalView',
				hideLink: false,
				order: 6,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingInvestigation', {
		abstract: false,
		url: '/charts/investigation/:acaUnit?workplanId&stateId',
		template: require('./chartsDetails/chartsDetails.html'),
		controller: 'chartsDetailsCtrl',
		controllerAs: 'cDetails',
		params: {
			idModule: 6
		},
		data: {
			displayName: 'Investigación',
			order: 2,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacher',
				hideLink: false,
				order: 1,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingAcadManagement',
				hideLink: false,
				order: 5,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidation',
				hideLink: false,
				order: 4,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingExtension',
				hideLink: false,
				order: 3,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingGlobalView',
				hideLink: false,
				order: 6,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingExtension', {
		abstract: false,
		url: '/charts/extension/:acaUnit?workplanId&stateId',
		template: require('./chartsDetails/chartsDetails.html'),
		controller: 'chartsDetailsCtrl',
		controllerAs: 'cDetails',
		params: {
			idModule: 4
		},
		data: {
			displayName: 'Extensión',
			order: 3,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacher',
				hideLink: false,
				order: 1,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingAcadManagement',
				hideLink: false,
				order: 5,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidation',
				hideLink: false,
				order: 4,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigation',
				hideLink: false,
				order: 2,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingGlobalView',
				hideLink: false,
				order: 6,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingGlobalView', {
		abstract: false,
		url: '/charts/globalView/:acaUnit?workplanId&stateId',
		template: require('./chartsDetails/chartsDetails.html'),
		controller: 'chartsDetailsCtrl',
		controllerAs: 'cDetails',
		params: {
			idModule: 0
		},
		data: {
			displayName: 'Vista general',
			order: 6,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacher',
				hideLink: false,
				order: 1,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingAcadManagement',
				hideLink: false,
				order: 5,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidation',
				hideLink: false,
				order: 4,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigation',
				hideLink: false,
				order: 2,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			},{
				name: 'strategicTracking.strategicTrackingExtension',
				hideLink: false,
				order: 3,
				params: {
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId"
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingTeacherDetails', {
		abstract: false,
		url: '/details/teacher/:teacherId/:acaUnit?workplanId&stateId',
		template: require('./detailsByTeacher/detailsByTeacher.html'),
		controller: 'detailsByTeacherCtrl',
		controllerAs: 'tDetails',
		data: {
			displayName: 'Docencia',
			order: 1,
			siblings: [{
				name: 'strategicTracking.strategicTrackingAcadManagementDetails',
				hideLink: false,
				order: 5,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidationDetails',
				hideLink: false,
				order: 4,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigationDetails',
				hideLink: false,
				order: 2,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingExtensionDetails',
				hideLink: false,
				order: 3,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			}]
		},
		params: {
			idModule: 2
		},
	})
	.state('strategicTracking.strategicTrackingAcadManagementDetails', {
		abstract: false,
		url: '/details/academicManagement/:teacherId/:acaUnit?workplanId&stateId',
		template: require('./detailsByTeacher/detailsByTeacher.html'),
		controller: 'detailsByTeacherCtrl',
		controllerAs: 'tDetails',
		params: {
			idModule: 3
		},
		data: {
			displayName: 'Gestión académica',
			order: 5,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacherDetails',
				hideLink: false,
				order: 1,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidationDetails',
				hideLink: false,
				order: 4,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigationDetails',
				hideLink: false,
				order: 2,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingExtensionDetails',
				hideLink: false,
				order: 3,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingConsolidationDetails', {
		abstract: false,
		url: '/details/consolidation/:teacherId/:acaUnit?workplanId&stateId',
		template: require('./detailsByTeacher/detailsByTeacher.html'),
		controller: 'detailsByTeacherCtrl',
		controllerAs: 'tDetails',
		params: {
			idModule: 5
		},
		data: {
			displayName: 'Consolidación de cuerpo profesoral',
			order: 4,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacherDetails',
				hideLink: false,
				order: 1,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingAcadManagementDetails',
				hideLink: false,
				order: 5,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigationDetails',
				hideLink: false,
				order: 2,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingExtensionDetails',
				hideLink: false,
				order: 3,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingInvestigationDetails', {
		abstract: false,
		url: '/details/investigation/:teacherId/:acaUnit?workplanId&stateId',
		template: require('./detailsByTeacher/detailsByTeacher.html'),
		controller: 'detailsByTeacherCtrl',
		controllerAs: 'tDetails',
		params: {
			idModule: 6
		},
		data: {
			displayName: 'Investigación',
			order: 2,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacherDetails',
				hideLink: false,
				order: 1,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingAcadManagementDetails',
				hideLink: false,
				order: 5,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidationDetails',
				hideLink: false,
				order: 4,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingExtensionDetails',
				hideLink: false,
				order: 3,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingExtensionDetails', {
		abstract: false,
		url: '/details/extension/:teacherId/:acaUnit?workplanId&stateId',
		template: require('./detailsByTeacher/detailsByTeacher.html'),
		controller: 'detailsByTeacherCtrl',
		controllerAs: 'tDetails',
		params: {
			idModule: 4
		},
		data: {
			displayName: 'Extensión',
			order: 3,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacherDetails',
				hideLink: false,
				order: 1,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingAcadManagementDetails',
				hideLink: false,
				order: 5,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidationDetails',
				hideLink: false,
				order: 4,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigationDetails',
				hideLink: false,
				order: 2,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			}]
		}
	})
	.state('strategicTracking.strategicTrackingGlobalViewDetails', {
		abstract: false,
		url: '/details/globalView/:teacherId/:acaUnit?workplanId&stateId',
		template: require('./detailsByTeacher/detailsByTeacher.html'),
		controller: 'detailsByTeacherCtrl',
		controllerAs: 'tDetails',
		params: {
			idModule: 0
		},
		data: {
			displayName: 'Gestión académica',
			order: 6,
			siblings: [{
				name: 'strategicTracking.strategicTrackingTeacherDetails',
				hideLink: false,
				order: 1,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingAcadManagementDetails',
				hideLink: false,
				order: 5,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingConsolidationDetails',
				hideLink: false,
				order: 4,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingInvestigationDetails',
				hideLink: false,
				order: 2,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			},{
				name: 'strategicTracking.strategicTrackingExtensionDetails',
				hideLink: false,
				order: 3,
				params: {
					teacherId: "teacherId",
					acaUnit: "acaUnit",
					workplanId: "workplanId",
					stateId: "stateId",
				}
			}]
		}
	});

}


// WEBPACK FOOTER //
// ./src/app/u-faculty/strategicTracking/strategicTracking.route.js